import "./WorkflowSteps.css";

import { useContext } from "react";

import { EmptyMilestonesIcon, RoundedPlusSignIcon } from "../../../../../../../assets";
import { OrganisationTypeConstants, WorkflowOrganisationAccessLevel } from "../../../../../../../constants";
import { ProjectPhase } from "../../../../../../../constants/project-phase";
import { ProjectPhaseStatus } from "../../../../../../../models";
import { useAuth } from "../../../../../../../useAuth";
import { Button, Column, Row } from "../../../../../../../widget";
import { TasksBoardContext } from "../../TasksBoardContext";
import { WorkflowStep } from "./components";

interface WorkflowStepsProps {
  handleAddWorkflowStep: () => void;
}

export const WorkflowSteps = ({ handleAddWorkflowStep }: WorkflowStepsProps): JSX.Element => {
  const { currentUserType } = useAuth();
  const { workflowSteps, hasAccessLevelAndCanEditTemplate, currentPhase, projectDates } = useContext(TasksBoardContext);

  return (
    <div className={`WorkflowStepsContainer ${workflowSteps && workflowSteps?.length > 0 ? "HasWorkflowSteps" : ""}`}>
      {workflowSteps && workflowSteps.length > 0
        ? workflowSteps?.map((workflowStep) => (
            <Row key={workflowStep.uuid} spacingV="ml">
              <Column span={12} hasNoPadding>
                <WorkflowStep workflowStep={workflowStep} />
              </Column>
            </Row>
          ))
        : ((currentPhase === ProjectPhase.feasibility &&
            projectDates?.dates.feasibility?.status !== ProjectPhaseStatus.COMPLETED) ||
            (currentPhase === ProjectPhase.design &&
              projectDates?.dates.design.status !== ProjectPhaseStatus.COMPLETED) ||
            (currentPhase === ProjectPhase.implementation &&
              projectDates?.dates.implementation.status !== ProjectPhaseStatus.COMPLETED) ||
            (currentPhase === ProjectPhase.ongoingMonitoring &&
              projectDates?.dates.ongoingMonitoring.overallStatus !== ProjectPhaseStatus.COMPLETED)) && (
            <div
              className={`EmptyWorkflowSteps ${
                currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "Rounded" : ""
              }`}
            >
              <Row spacingV="l" justify="center">
                <Column span={6}>
                  <EmptyMilestonesIcon />
                </Column>
              </Row>
              {hasAccessLevelAndCanEditTemplate(WorkflowOrganisationAccessLevel.Contributor) ? (
                <>
                  <Row spacingV="ml" justify="center">
                    <Column span={6}>
                      <h1>This phase has no incomplete steps</h1>
                    </Column>
                  </Row>
                  <Row spacingV="ll" justify="center">
                    <Column span={6}>
                      <p className="body1">Add steps to outline what needs to happen in this phase of your project</p>
                    </Column>
                  </Row>
                  <Row justify="center">
                    <Column span={2} hasNoPadding>
                      <Button
                        text="Add step"
                        variant="primary"
                        hasNoPadding
                        size="small"
                        icon={<RoundedPlusSignIcon className="RoundedPlusSignIcon" />}
                        fullWidth
                        onClick={handleAddWorkflowStep}
                      />
                    </Column>
                  </Row>
                </>
              ) : (
                <Row spacingV="ml" justify="center">
                  <Column span={6}>
                    <h1>This phase has no steps</h1>
                  </Column>
                </Row>
              )}
            </div>
          )}
    </div>
  );
};
